webpackJsonp([1],{

/***/ "+rw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__ = __webpack_require__("gtZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__ = __webpack_require__("fnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_config__ = __webpack_require__("vgQg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("2G0z");






/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			message: "正在进行系统初始化。。。",
			checkTime: "",
			devSn: "",
			versionNo: "V3006",
			gateInfo: { store_name: "未获取" },
			checkFlag: true,
			debugFlag: false, //工厂测试模式
			logoHeight: 600,
			fontSize: 44
		};
	},


	mounted: function mounted() {
		// alert(window.screen.availHeight);
		if (window.screen.availHeight <= 500) {
			this.fontSize = 39;
		} else {
			this.fontSize = 44;
		}
		this.logoHeight = (window.screen.availHeight * 1 - 340) / 2;
		global.LOCAL_DATA.devInfo.checkFlag = false;
		try {
			this.init();
		} catch (e) {
			this.message = "系统初始化失败";
		}
	},

	methods: {

		init: function init() {
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, "", "", "");
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0);
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "二维码设备打开状态：" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0));
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, "", "", "");
			try {
				var result = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, "", "", "");
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "打开身份证阅读器结果:" + result + ",设备信息:" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["d" /* getLastMsg */]());
				result = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 0);
				if (result != 0) {
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "身份证阅读器启用失败");
				}
			} catch (e) {}

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__["a" /* setCallBackFun */])(this.callBack);
			//todo 序列号验证，终端信息初始化
			global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
			//  global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";
			this.netInit();
		},

		netInit: function netInit() {
			this.devSn = global.LOCAL_DATA.devInfo.devSn;
			var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			var that = this;
			var url = "";
			if (reqData.sign == "") {
				url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
			} else {
				url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
			}
			this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
				if (response.data.status == "success") {
					that.message = "请将票券上的二维码放在扫码器前扫码验票";
					global.LOCAL_DATA.systemInfo = response.data.systemInfo;
					that.gateInfo = response.data.gateInfo;
					that.debugFlag = false;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化成功，请将票券上的二维码放在扫码器前扫码验票");
				} else {
					that.message = response.data.msg;
					global.LOCAL_DATA.systemInfo = response.data.systemInfo;
					that.debugFlag = true;
					setTimeout(function () {
						that.netInit();
					}, 15000);
				}
			}).catch(function (error) {
				that.message = "网络异常，正在重新获取配置信息";
				that.debugFlag = true;
				if (that && !that._isDestroyed) {
					setTimeout(function () {
						if (that && !that._isDestroyed) that.netInit();
					}, 15000);
				}
			});
		},

		callBack: function callBack(DeviceID, UserEvtID, RetCode, RetMsg) {
			switch (DeviceID) {
				//二维码阅读器
				case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE:
					this.onCodeEvent(UserEvtID, RetCode, RetMsg);
					break;
				case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID:
					this.onIdEvent(UserEvtID, RetCode, RetMsg);
					break;
			}
		},

		test: function test() {
			this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
			//                this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
		},

		//二维码验票
		onCodeEvent: function onCodeEvent(UserEvtID, RetCode, RetMsg) {
			if (global.LOCAL_DATA.devInfo.checkFlag) return;
			global.LOCAL_DATA.devInfo.checkFlag = true;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在验票");
			if (RetMsg.indexOf("employee") >= 0) {
				this.message = "员工验码";
				this.employeeCheck(RetMsg);
			} else {
				this.message = "正在验票";
				this.check(RetMsg);
			}
		},

		//身份证验票
		onIdEvent: function onIdEvent(UserEvtID, RetCode, RetMsg) {
			if (global.LOCAL_DATA.devInfo.checkFlag) return;
			global.LOCAL_DATA.devInfo.checkFlag = true;
			var idInfo = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDReadData(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 5);
			this.message = "正在身份证验票";
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在身份证验票");
			var idCardInfo = "TL_003_" + idInfo.split("|")[5];
			this.check(idCardInfo);
		},

		msgRestore: function msgRestore() {
			var that = this;
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 0);
				that.message = "请将票券上的二维码放在扫码器前扫码验票";
			}, 5000);
		},

		employeeCheck: function employeeCheck(qrCode) {
			if (!this.checkFlag) return;
			this.checkFlag = false;
			var that = this;
			var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			reqData.gate_uid = this.gateInfo.gate_uid;
			reqData.gate_type = this.gateInfo.gate_type;
			reqData.enterprise_uid = this.gateInfo.enterprise_uid;
			reqData.qr_code = qrCode;
			var url = "";
			if (reqData.sign == "") {
				url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
			} else {
				url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
			}
			this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
				if (response.data.status == "success") {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					//开闸
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
					that.msgRestore();
				} else {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					that.msgRestore();
				}

				setTimeout(function () {
					that.checkFlag = true;
					global.LOCAL_DATA.devInfo.checkFlag = false;
				}, 500);
			}).catch(function (error) {
				global.LOCAL_DATA.devInfo.checkFlag = false;
				that.message = "网络异常，验票失败,请重试";
				that.checkFlag = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
				that.msgRestore();
			});
		},

		//扫码验票
		check: function check(qrCode) {
			if (!this.checkFlag) return;
			this.checkFlag = false;

			if (qrCode == "TL20180808752033987" && this.debugFlag) {
				this.message = "请注意，测试验票成功，请入闸";
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(this.message);
				//开闸
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
				this.checkFlag = true;
				global.LOCAL_DATA.devInfo.checkFlag = false;
				this.msgRestore();
				return;
			}
			var that = this;
			var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			reqData.gate_uid = this.gateInfo.gate_uid;
			reqData.gate_type = this.gateInfo.gate_type;
			reqData.enterprise_uid = this.gateInfo.enterprise_uid;
			reqData.store_uid = this.gateInfo.store_uid;
			reqData.qr_code = qrCode;
			var url = "";
			if (reqData.sign == "") {
				url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
			} else {
				url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
			}
			this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
				if (response.data.status == "success") {
					that.message = response.data.msg;
					//开闸
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					that.msgRestore();
					setTimeout(function () {
						that.checkFlag = true;
						global.LOCAL_DATA.devInfo.checkFlag = false;
					}, 3000);
				} else {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					that.msgRestore();
					setTimeout(function () {
						that.checkFlag = true;
						global.LOCAL_DATA.devInfo.checkFlag = false;
					}, 500);
				}
			}).catch(function (error) {
				global.LOCAL_DATA.devInfo.checkFlag = false;
				that.message = "网络异常，验票失败,请重试";
				that.checkFlag = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
				that.msgRestore();
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "/oqc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0ypA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1kXy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2G0z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TIRz");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./Check.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./Check.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3pbd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, "body {\n  background-color: #172894;\n  color: whitesmoke;\n  font-family: \"Microsoft YaHei\" ! important;\n  font-size: 30px;\n}\n.header {\n  height: 100px;\n  line-height: 100px;\n  font-size: 45px;\n}\n.content {\n  padding-top: 40px;\n}\n.footer {\n  margin-top: 15px;\n  height: 100px;\n  font-size: 25px;\n  padding-left: 30px;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n#faceStyle {\n  width: 400px;\n  height: 330px;\n  position: fixed;\n  top: 230px;\n  left: 40px;\n}\n", ""]);

// exports


/***/ }),

/***/ "Ag2x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E4i5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G/Mw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faceCheck_vue__ = __webpack_require__("fI0w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9541c640_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faceCheck_vue__ = __webpack_require__("cb7z");
function injectStyle (ssrContext) {
  __webpack_require__("hPLS")
  __webpack_require__("1kXy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faceCheck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9541c640_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faceCheck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JuC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/**
 * Created by zoupeiyang on 2018/3/29.
 */
var install = function install(Vue) {
    var Bus = new Vue({
        methods: {
            emit: function emit(event) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                this.$emit.apply(this, [event].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
            },
            on: function on(event, callback) {
                this.$on(event, callback);
            },
            off: function off(event, callback) {
                this.$off(event, callback);
            }
        }
    });
    Vue.prototype.$bus = Bus;
};

/* harmony default export */ __webpack_exports__["a"] = (install);

/***/ }),

/***/ "LBBc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LGhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_jssFunction__ = __webpack_require__("gtZW");

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msg: "系统正在初始化...",
      errShow: false
    };
  },

  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      var devSn = "";
      try {
        if (global.LOCAL_DATA.devInfo.debug) {
          global.LOCAL_DATA.devInfo.devSn = "TL_MY_01";
        } else {
          devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_jssFunction__["d" /* getQueryString */]("v");
          if (devSn == "TL_MY_2" || devSn == "TL_JQ_2" || devSn == "TL_CY_2" || devSn == "TL_MY_01") {
            global.LOCAL_DATA.devInfo.devSn = devSn;
          } else {
            global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
          }
        }
      } catch (e) {
        this.msg = "售票客户端尚未安装或安装失败";
        return;
      }

      //   let devSn = "TL_JQ_22";
      var that = this;
      var reqData = {};
      reqData.dev_sn = devSn;
      this.$http.post(this.GlobalConfig.APP_CONFIG.API_HOST + "init", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          var url = response.data.devInfo.version_url;
          if (devSn == "TL_MY_2" || devSn == "TL_JQ_2" || devSn == "TL_CY_2" || devSn == "TL_MY_01") {
            url = response.data.devInfo.version_url + "?v=" + devSn;
          }

          window.location.href = url;
        } else {
          that.msg = response.data.msg;
          that.errShow = true;
        }
      }).catch(function () {
        that.msg = "网络异常，请退出检查终端机是否已经联网";
        that.errShow = true;
        setTimeout(function () {
          that.init();
        }, 20000);
      });
    },
    //退出系统
    quit: function quit() {
      if (__WEBPACK_IMPORTED_MODULE_2__assets_js_jssFunction__["e" /* androidClick */]()) return;
      __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().SystemCtrl(10);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "LYXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check2_vue__ = __webpack_require__("QOuM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_969dce36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check2_vue__ = __webpack_require__("cK5R");
function injectStyle (ssrContext) {
  __webpack_require__("Ag2x")
  __webpack_require__("E4i5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_969dce36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc7415e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("tEpX");
function injectStyle (ssrContext) {
  __webpack_require__("V6ar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc7415e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_grobalData__ = __webpack_require__("q0u+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_grobalData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_js_grobalData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_config__ = __webpack_require__("vgQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_bus__ = __webpack_require__("JuC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_min_css__);
var _this = this;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import VueRouter from 'vue-router';

// import axios from 'axios'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'

// import EnLocale from 'element-ui/lib/locale/lang/en'
// import ZhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import VueResource from 'vue-resource'
// import 'babel-polyfill'










//解决部分IE浏览器console出错问题
window.console = window.console || function () {
    var c = {};c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function () {};
    return c;
}();

__webpack_require__("wfMF");
// require('!style-loader!css-loader!less-loader!./assets/theme/blue.less')
//引入element-ui的动画样式

// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
//     // require('videojs-contrib-hls/dist/videojs-contrib-hls');
//
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.GlobalConfig = __WEBPACK_IMPORTED_MODULE_7__assets_js_config__;
// Vue.use(VueRouter);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__vue_bus__["a" /* default */]);

//系统错误捕获
var errorHandler = function errorHandler(error, vm) {
    // console.error('抛出全局异常');
    // console.error(vm);
    // console.error(error);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__assets_js_deviceOperate__["a" /* writeAppLog */])(1, "全局异常：" + error);
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.errorHandler = errorHandler;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$throw = function (error) {
    return errorHandler(error, _this);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('imgFilter', function (value) {

    return "http://image.tl-self.com" + value;
    // return '../static/image/demo.jpeg';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("textFilter", function (value) {
    if (value.length > 7) {
        return value.slice(0, 7) + "...";
    } else {
        return value;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("hideMiddle", function (val) {
    return val.slice(0, 6) + '****' + val.slice(val.length - 4);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Ogus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingContent",attrs:{"id":"load"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.oemShow),expression:"oemShow"}]},[_vm._m(0,false,false)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageWrongFlag),expression:"pageWrongFlag"}],staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center",staticStyle:{"font-size":"30px","margin-top":"50px","color":"red"}},[_vm._v(_vm._s(_vm.wrongMsg))]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center",staticStyle:{"margin-top":"50px"}},[_c('button',{staticClass:"btn btn-warning btn-lg",attrs:{"type":"button"},on:{"click":function($event){_vm.quit()},"touchstart":function($event){_vm.quit()}}},[_vm._v("退出应用")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center",staticStyle:{"font-size":"50px","margin-top":"300px","color":"white"}},[_vm._v("系统正在初始化中...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QCR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HandCheck_vue__ = __webpack_require__("aQ0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee7c34c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HandCheck_vue__ = __webpack_require__("pXlv");
function injectStyle (ssrContext) {
  __webpack_require__("p91O")
  __webpack_require__("tPum")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HandCheck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee7c34c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HandCheck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QLI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row header jss-transparent"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('span',[_vm._v("自助检票系统"+_vm._s(_vm.versionNo))])])]),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"font-weight":"500"},style:({'margin-top':_vm.logoHeight+'px','font-size':_vm.fontSize+'px'})},[_c('div',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.checkTime))])])]),_vm._v(" "),_c('div',{staticClass:"row footer jss-transparent navbar navbar-default navbar-fixed-bottom"},[_c('div',{staticClass:"col-lg-12"},[_vm._v("\n      本机序列号：\n      "),_c('span',[_vm._v(_vm._s(_vm.devSn))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.gateInfo.store_name)+" "+_vm._s(_vm.versionNo))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QOuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__ = __webpack_require__("gtZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__ = __webpack_require__("fnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_config__ = __webpack_require__("vgQg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("2G0z");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: "正在进行系统初始化。。。",
      checkTime: "",
      devSn: "",
      versionNo: "V3006",
      gateInfo: { store_name: "未获取" },
      checkFlag: true,
      debugFlag: false, //工厂测试模式
      logoHeight: 600,
      fontSize: 44
    };
  },


  mounted: function mounted() {
    // alert(window.screen.availHeight);
    if (window.screen.availHeight <= 500) {
      this.fontSize = 39;
    } else {
      this.fontSize = 44;
    }
    this.logoHeight = (window.screen.availHeight * 1 - 340) / 2;
    global.LOCAL_DATA.devInfo.checkFlag = false;
    try {
      this.init();
    } catch (e) {
      this.message = "系统初始化失败";
    }
  },

  methods: {
    init: function init() {
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, "", "", "");
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0);
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "二维码设备打开状态：" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0));
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, "", "", "");
      try {
        var result = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, "", "", "");
        __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "打开身份证阅读器结果:" + result + ",设备信息:" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["d" /* getLastMsg */]());
        result = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 0);
        if (result != 0) {
          __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "身份证阅读器启用失败");
        }
      } catch (e) {}

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__["a" /* setCallBackFun */])(this.callBack);
      //todo 序列号验证，终端信息初始化
      global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
      //  global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";
      this.netInit();
    },

    netInit: function netInit() {
      this.devSn = global.LOCAL_DATA.devInfo.devSn;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      var that = this;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = "请将票券上的二维码放在扫码器前扫码验票";
          global.LOCAL_DATA.systemInfo = response.data.systemInfo;
          that.gateInfo = response.data.gateInfo;
          that.debugFlag = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化成功，请将票券上的二维码放在扫码器前扫码验票");
        } else {
          that.message = response.data.msg;
          global.LOCAL_DATA.systemInfo = response.data.systemInfo;
          that.debugFlag = true;
          setTimeout(function () {
            that.netInit();
          }, 15000);
        }
      }).catch(function (error) {
        that.message = "网络异常，正在重新获取配置信息";
        that.debugFlag = true;
        if (that && !that._isDestroyed) {
          setTimeout(function () {
            if (that && !that._isDestroyed) that.netInit();
          }, 15000);
        }
      });
    },

    callBack: function callBack(DeviceID, UserEvtID, RetCode, RetMsg) {
      switch (DeviceID) {
        //二维码阅读器
        case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE:
          this.onCodeEvent(UserEvtID, RetCode, RetMsg);
          break;
        case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID:
          this.onIdEvent(UserEvtID, RetCode, RetMsg);
          break;
      }
    },

    test: function test() {
      this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
      //                this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
    },

    //二维码验票
    onCodeEvent: function onCodeEvent(UserEvtID, RetCode, RetMsg) {
      if (global.LOCAL_DATA.devInfo.checkFlag) return;
      global.LOCAL_DATA.devInfo.checkFlag = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在验票");
      if (RetMsg.indexOf("employee") >= 0) {
        this.message = "员工验码";
        this.employeeCheck(RetMsg);
      } else {
        this.message = "正在验票";
        this.check(RetMsg);
      }
    },

    //身份证验票
    onIdEvent: function onIdEvent(UserEvtID, RetCode, RetMsg) {
      if (global.LOCAL_DATA.devInfo.checkFlag) return;
      global.LOCAL_DATA.devInfo.checkFlag = true;
      var idInfo = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDReadData(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 5);
      this.message = "正在身份证验票";
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在身份证验票");
      var idCardInfo = "TL_003_" + idInfo.split("|")[5];
      this.check(idCardInfo);
    },

    msgRestore: function msgRestore() {
      var that = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 0);
        that.message = "请将票券上的二维码放在扫码器前扫码验票";
      }, 5000);
    },

    employeeCheck: function employeeCheck(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      var that = this;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      reqData.gate_uid = this.gateInfo.gate_uid;
      reqData.gate_type = this.gateInfo.gate_type;
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.qr_code = qrCode;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          //开闸
          __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
          that.msgRestore();
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
        }

        setTimeout(function () {
          that.checkFlag = true;
          global.LOCAL_DATA.devInfo.checkFlag = false;
        }, 500);
      }).catch(function (error) {
        global.LOCAL_DATA.devInfo.checkFlag = false;
        that.message = "网络异常，验票失败,请重试";
        that.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
        that.msgRestore();
      });
    },

    //扫码验票
    check: function check(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;

      if (qrCode == "TL20180808752033987" && this.debugFlag) {
        this.message = "请注意，测试验票成功，请入闸";
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(this.message);
        //开闸
        __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
        this.checkFlag = true;
        global.LOCAL_DATA.devInfo.checkFlag = false;
        this.msgRestore();
        return;
      }
      var that = this;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      reqData.gate_uid = this.gateInfo.gate_uid;
      reqData.gate_type = this.gateInfo.gate_type;
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.store_uid = this.gateInfo.store_uid;
      reqData.qr_code = qrCode;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = response.data.msg;
          //开闸
          __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
          setTimeout(function () {
            that.checkFlag = true;
            global.LOCAL_DATA.devInfo.checkFlag = false;
          }, 3000);
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
          setTimeout(function () {
            that.checkFlag = true;
            global.LOCAL_DATA.devInfo.checkFlag = false;
          }, 500);
        }
      }).catch(function (error) {
        global.LOCAL_DATA.devInfo.checkFlag = false;
        that.message = "网络异常，验票失败,请重试";
        that.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
        that.msgRestore();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "RzE1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TIRz":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, "body {\n  background-color: #172894;\n  color: whitesmoke;\n  font-family: \"Microsoft YaHei\" ! important;\n  font-size: 30px;\n}\n.header {\n  height: 120px;\n  line-height: 120px;\n  font-size: 45px;\n}\n.content {\n  padding-top: 40px;\n}\n.footer {\n  height: 100px;\n  line-height: 100px;\n  font-size: 25px;\n  padding-left: 30px;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n", ""]);

// exports


/***/ }),

/***/ "U6dJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HandCheck2_vue__ = __webpack_require__("Z9pK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee7c34c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HandCheck2_vue__ = __webpack_require__("dAvA");
function injectStyle (ssrContext) {
  __webpack_require__("/oqc")
  __webpack_require__("RzE1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HandCheck2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee7c34c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HandCheck2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V6ar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XC1+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3pbd");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./Check.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./Check.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XdY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_init_vue__ = __webpack_require__("LGhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7632f23a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_init_vue__ = __webpack_require__("fMF4");
function injectStyle (ssrContext) {
  __webpack_require__("LBBc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7632f23a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_init_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7632f23a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_init_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Index__ = __webpack_require__("mlqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_gateCheck_Check__ = __webpack_require__("fN6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_handCheck_HandCheck__ = __webpack_require__("QCR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_gateCheck_Check2__ = __webpack_require__("LYXb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_handCheck_HandCheck2__ = __webpack_require__("U6dJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_faceCheck_faceCheck__ = __webpack_require__("G/Mw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_init__ = __webpack_require__("XdY3");




// import FullScreenAd from '@/views/FullScreenAd'









//2018-11-30


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Index',
        component: __WEBPACK_IMPORTED_MODULE_2__views_Index__["a" /* default */]
    }, {
        path: '/check',
        name: 'check',
        component: __WEBPACK_IMPORTED_MODULE_3__views_gateCheck_Check__["a" /* default */]
    }, {
        path: '/handCheck',
        name: 'handCheck',
        component: __WEBPACK_IMPORTED_MODULE_4__views_handCheck_HandCheck__["a" /* default */]
    }, {
        path: '/check2',
        name: 'check2',
        component: __WEBPACK_IMPORTED_MODULE_5__views_gateCheck_Check2__["a" /* default */]
    }, {
        path: '/handCheck2',
        name: 'handCheck2',
        component: __WEBPACK_IMPORTED_MODULE_6__views_handCheck_HandCheck2__["a" /* default */]
    }, {
        path: '/faceCheck',
        name: 'faceCheck',
        component: __WEBPACK_IMPORTED_MODULE_7__views_faceCheck_faceCheck__["a" /* default */]
    }]
}));

/***/ }),

/***/ "Z9pK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__ = __webpack_require__("gtZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__ = __webpack_require__("fnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_config__ = __webpack_require__("vgQg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("rMqd");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: "正在进行系统初始化。。。",
      checkTime: "",
      devSn: "",
      versionNo: "V3006",
      gateInfo: { store_name: "未获取" },
      checkFlag: true
    };
  },


  mounted: function mounted() {
    global.LOCAL_DATA.devInfo.checkFlag = false;
    try {
      this.init();
    } catch (e) {
      this.message = "系统初始化失败";
    }
  },

  methods: {
    init: function init() {
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, "", "", "");
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0);
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "二维码设备打开状态：" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0));
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, "", "", "");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__["a" /* setCallBackFun */])(this.callBack);
      //todo 序列号验证，终端信息初始化
      global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
      //  global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";

      this.devSn = global.LOCAL_DATA.devInfo.devSn;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      var that = this;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = "请扫描票券上的二维码验票";
          global.LOCAL_DATA.systemInfo = response.data.systemInfo;
          that.gateInfo = response.data.gateInfo;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化成功，请将票券上的二维码放在扫码器前扫码验票");
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化失败，失败原因：" + that.message + "，正在重试初始化");

          setTimeout(function () {
            that.init();
          }, 10000);
        }
      }).catch(function (error) {
        that.message = "网络异常，正在重新获取配置信息";
        if (that && !that._isDestroyed) {
          setTimeout(function () {
            if (that && !that._isDestroyed) that.init();
          }, 10000);
        }
      });
    },

    callBack: function callBack(DeviceID, UserEvtID, RetCode, RetMsg) {
      switch (DeviceID) {
        //二维码阅读器
        case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE:
          this.onCodeEvent(UserEvtID, RetCode, RetMsg);
          break;
      }
    },

    test: function test() {
      this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
      //                this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
    },

    onCodeEvent: function onCodeEvent(UserEvtID, RetCode, RetMsg) {
      var that = this;
      setTimeout(function () {
        if (global.LOCAL_DATA.devInfo.checkFlag) {
          return;
        }
        global.LOCAL_DATA.devInfo.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在验票");
        if (RetMsg.indexOf("employee") >= 0) {
          that.message = "员工验码";
          that.employeeCheck(RetMsg);
        } else {
          that.message = "正在验票";
          that.check(RetMsg);
        }
      }, 500 * parseInt(Math.random()));
    },

    msgRestore: function msgRestore() {
      var that = this;
      setTimeout(function () {
        that.message = "请扫描票券上二维码验票";
      }, 2000);
    },

    employeeCheck: function employeeCheck(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      var that = this;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.qr_code = qrCode;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          //开闸
          //                            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 3000);
          that.msgRestore();
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
        }

        setTimeout(function () {
          that.checkFlag = true;
          global.LOCAL_DATA.devInfo.checkFlag = false;
        }, 500);
      }).catch(function (error) {
        global.LOCAL_DATA.devInfo.checkFlag = false;
        that.message = "网络异常，验票失败,请重试";
        that.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
      });
    },

    //扫码验票
    check: function check(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      var that = this;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      reqData.gate_uid = this.gateInfo.gate_uid;
      reqData.gate_type = this.gateInfo.gate_type;
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.store_uid = this.gateInfo.store_uid;
      reqData.qr_code = qrCode;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          //开闸
          //                            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 3000);
          that.msgRestore();
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
        }
        setTimeout(function () {
          that.checkFlag = true;
          global.LOCAL_DATA.devInfo.checkFlag = false;
        }, 500);
      }).catch(function (error) {
        global.LOCAL_DATA.devInfo.checkFlag = false;
        that.message = "网络异常，验票失败,请重试";
        that.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
        that.msgRestore();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "aQ0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__ = __webpack_require__("gtZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__ = __webpack_require__("fnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_config__ = __webpack_require__("vgQg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("rMqd");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: "正在进行系统初始化。。。",
      checkTime: "",
      devSn: "",
      versionNo: "V3006",
      gateInfo: { store_name: "未获取" },
      checkFlag: true
    };
  },


  mounted: function mounted() {
    global.LOCAL_DATA.devInfo.checkFlag = false;
    try {
      this.init();
    } catch (e) {
      this.message = "系统初始化失败";
    }
  },

  methods: {
    init: function init() {
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, "", "", "");
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0);
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "二维码设备打开状态：" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0));
      __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, "", "", "");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__["a" /* setCallBackFun */])(this.callBack);
      //todo 序列号验证，终端信息初始化
      global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
      //  global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";

      this.devSn = global.LOCAL_DATA.devInfo.devSn;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      var that = this;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = "请扫描票券上的二维码验票";
          global.LOCAL_DATA.systemInfo = response.data.systemInfo;
          that.gateInfo = response.data.gateInfo;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化成功，请将票券上的二维码放在扫码器前扫码验票");
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化失败，失败原因：" + that.message + "，正在重试初始化");

          setTimeout(function () {
            that.init();
          }, 10000);
        }
      }).catch(function (error) {
        that.message = "网络异常，正在重新获取配置信息";
        if (that && !that._isDestroyed) {
          setTimeout(function () {
            if (that && !that._isDestroyed) that.init();
          }, 10000);
        }
      });
    },

    callBack: function callBack(DeviceID, UserEvtID, RetCode, RetMsg) {
      switch (DeviceID) {
        //二维码阅读器
        case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE:
          this.onCodeEvent(UserEvtID, RetCode, RetMsg);
          break;
      }
    },

    test: function test() {
      this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
      //                this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
    },

    onCodeEvent: function onCodeEvent(UserEvtID, RetCode, RetMsg) {
      var that = this;
      setTimeout(function () {
        if (global.LOCAL_DATA.devInfo.checkFlag) {
          return;
        }
        global.LOCAL_DATA.devInfo.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在验票");
        if (RetMsg.indexOf("employee") >= 0) {
          that.message = "员工验码";
          that.employeeCheck(RetMsg);
        } else {
          that.message = "正在验票";
          that.check(RetMsg);
        }
      }, 500 * parseInt(Math.random()));
    },

    msgRestore: function msgRestore() {
      var that = this;
      setTimeout(function () {
        that.message = "请扫描票券上二维码验票";
      }, 2000);
    },

    employeeCheck: function employeeCheck(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      var that = this;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.qr_code = qrCode;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          //开闸
          //                            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 3000);
          that.msgRestore();
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
        }

        setTimeout(function () {
          that.checkFlag = true;
          global.LOCAL_DATA.devInfo.checkFlag = false;
        }, 500);
      }).catch(function (error) {
        global.LOCAL_DATA.devInfo.checkFlag = false;
        that.message = "网络异常，验票失败,请重试";
        that.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
      });
    },

    //扫码验票
    check: function check(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      var that = this;
      var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
      reqData.gate_uid = this.gateInfo.gate_uid;
      reqData.gate_type = this.gateInfo.gate_type;
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.store_uid = this.gateInfo.store_uid;
      reqData.qr_code = qrCode;
      var url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
      } else {
        url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
      }
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
        if (response.data.status == "success") {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          //开闸
          //                            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 3000);
          that.msgRestore();
        } else {
          that.message = response.data.msg;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
          that.msgRestore();
        }
        setTimeout(function () {
          that.checkFlag = true;
          global.LOCAL_DATA.devInfo.checkFlag = false;
        }, 500);
      }).catch(function (error) {
        global.LOCAL_DATA.devInfo.checkFlag = false;
        that.message = "网络异常，验票失败,请重试";
        that.checkFlag = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
        that.msgRestore();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "cK5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"font-weight":"500"},style:({'margin-top':_vm.logoHeight+'px','font-size':_vm.fontSize+'px'})},[_c('div',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.checkTime))])])]),_vm._v(" "),_c('div',{staticClass:"row footer jss-transparent navbar navbar-default navbar-fixed-bottom"},[_c('div',{staticClass:"col-lg-12"},[_vm._v("\n      本机序列号：\n      "),_c('span',[_vm._v(_vm._s(_vm.devSn))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.gateInfo.store_name)+" "+_vm._s(_vm.versionNo))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row header jss-transparent"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('span',[_vm._v("自助检票系统")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cb7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row header jss-transparent"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('span',[_vm._v("自助检票系统"+_vm._s(_vm.versionNo))])])]),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"height":"435px"}}),_vm._v(" "),_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"padding-top":"10px","font-size":"38px"}},[_c('div',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.checkTime))])])]),_vm._v(" "),_c('div',{staticClass:"row footer jss-transparent navbar navbar-default navbar-fixed-bottom"},[_c('div',{staticClass:"col-lg-6",staticStyle:{"margin-top":"5px"}},[_vm._v("\n\t\t\t本机序列号："),_c('span',[_vm._v(_vm._s(_vm.devSn))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_vm._v("\n\t\t\t"+_vm._s(_vm.gateInfo.store_name)+" "),_c('span',{staticStyle:{"margin-left":"15px"}},[_vm._v(" "+_vm._s(_vm.versionNo))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ckk5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dAvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row header2 jss-transparent"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('span',{staticStyle:{"font-size":"30px"}},[_vm._v("手持检票系统"+_vm._s(_vm.versionNo))])])]),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"padding-top":"30px","font-size":"20px"}},[_c('div',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.checkTime))])])]),_vm._v(" "),_c('div',{staticClass:"row jss-transparent navbar navbar-default navbar-fixed-bottom",staticStyle:{"height":"60px","font-size":"14px","padding-left":"15px"}},[_c('div',{staticClass:"col-lg-12",staticStyle:{"line-height":"30px"}},[_vm._v("本机序列号：\n\t\t\t"),_c('span',[_vm._v(_vm._s(_vm.devSn))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"15px"}},[_vm._v(_vm._s(_vm.versionNo))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('span',[_vm._v(_vm._s(_vm.gateInfo.store_name))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dPHu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fI0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__ = __webpack_require__("gtZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__ = __webpack_require__("fnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_config__ = __webpack_require__("vgQg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("XC1+");






/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			message: "正在进行系统初始化...",
			checkTime: "",
			devSn: "",
			versionNo: "V3004",
			gateInfo: { store_name: "未获取" },
			checkFlag: true,
			debugFlag: false, //工厂测试模式
			faceToken: "",
			groupId: "",
			checkStatus: false
		};
	},


	mounted: function mounted() {
		global.LOCAL_DATA.devInfo.checkFlag = false;
		try {
			this.init();
		} catch (e) {
			this.message = "系统初始化失败";
		}
	},

	methods: {
		init: function init() {
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, "", "", "");
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0);
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "二维码设备打开状态：" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().BRStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE, 0));
			__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, "", "", "");
			try {
				var result = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["c" /* openDevice */](__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, "", "", "");
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "打开身份证阅读器结果:" + result + ",设备信息:" + __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["d" /* getLastMsg */]());
				result = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 0);
				if (result != 0) {
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "身份证阅读器启用失败");
				}
			} catch (e) {}

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_js_devcieCallback__["a" /* setCallBackFun */])(this.callBack);
			//todo 序列号验证，终端信息初始化
			global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
			// global.LOCAL_DATA.devInfo.devSn = "43A675B725961899";
			// global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";
			this.netInit();
		},

		netInit: function netInit() {

			this.devSn = global.LOCAL_DATA.devInfo.devSn;
			var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			var that = this;
			var url = "";
			if (reqData.sign == "") {
				url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
			} else {
				url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
			}
			this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {

				if (response.data.status == "success") {
					that.message = "请面对摄像头刷脸验票或将票券上的二维码放在扫码器前扫码验票";
					global.LOCAL_DATA.systemInfo = response.data.systemInfo;
					that.gateInfo = response.data.gateInfo;
					that.debugFlag = false;
					that.faceToken = response.data.systemInfo.devInfo.baidu_face_token;
					that.groupId = response.data.gateInfo.store_uid;
					try {
						var ret = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().faceInit(that.faceToken, 0, 180, 600, 320);
						if (ret != 0) {
							__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["a" /* writeAppLog */](4, "摄像头初始化失败");
						} else {
							__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().faceSearchUser(1, that.groupId, 90, 0);
						}
					} catch (e) {}
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("系统初始化成功，请将票券上的二维码放在扫码器前扫码验票");
				} else {
					that.message = response.data.msg;
					global.LOCAL_DATA.systemInfo = response.data.systemInfo;
					that.debugFlag = true;
					setTimeout(function () {
						that.netInit();
					}, 15000);
				}
			}).catch(function (error) {
				that.message = "网络异常，正在重新获取配置信息";
				that.debugFlag = true;
				if (that && !that._isDestroyed) {
					setTimeout(function () {
						if (that && !that._isDestroyed) that.netInit();
					}, 15000);
				}
			});
		},

		callBack: function callBack(DeviceID, UserEvtID, RetCode, RetMsg) {
			switch (DeviceID) {
				//二维码阅读器
				case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_CODE:
					this.checkStatus = true;
					this.onCodeEvent(UserEvtID, RetCode, RetMsg);
					break;
				case __WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID:
					this.checkStatus = true;
					this.onIdEvent(UserEvtID, RetCode, RetMsg);
					break;
				case 920:
					this.onfaceEvent(UserEvtID, RetCode, RetMsg);
					break;
			}
		},

		test: function test() {
			this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
			//this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
		},

		//二维码验票
		onCodeEvent: function onCodeEvent(UserEvtID, RetCode, RetMsg) {
			if (global.LOCAL_DATA.devInfo.checkFlag) return;
			global.LOCAL_DATA.devInfo.checkFlag = true;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在验票");
			if (RetMsg.indexOf("employee") >= 0) {
				this.message = "员工验码";
				this.employeeCheck(RetMsg);
			} else {
				this.message = "正在验票";
				this.check(RetMsg);
			}
		},

		//身份证验票
		onIdEvent: function onIdEvent(UserEvtID, RetCode, RetMsg) {
			if (global.LOCAL_DATA.devInfo.checkFlag) return;
			global.LOCAL_DATA.devInfo.checkFlag = true;
			var idInfo = __WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDReadData(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 5);
			this.message = "正在身份证验票";
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("正在身份证验票");
			var idCardInfo = "TL_003_" + idInfo.split("|")[5];
			this.check(idCardInfo);
		},

		//人脸验票
		onfaceEvent: function onfaceEvent(UserEvtID, RetCode, RetMsg) {
			var that = this;
			console.log(RetCode);
			if (this.checkStatus) {
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().faceSearchUser(1, that.groupId, 90, 0);
				return;
			}
			if (RetCode == 12002) {
				if (global.LOCAL_DATA.devInfo.checkFlag) return;
				global.LOCAL_DATA.devInfo.checkFlag = true;
				that.message = "人脸匹配成功，正在验票";
				that.faceChecking(UserEvtID);
			} else if (RetCode == 10000) {} else if (RetCode == 32000) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])("人脸匹配失败，请重试");
				that.message = "请面对摄像头刷脸验票或将票券上的二维码放在扫码器前扫码验票";
			} else if (RetCode == 12001) {
				that.message = "人脸匹配中，请稍后...";
			} else {
				setTimeout(function () {
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().faceSearchUser(1, that.groupId, 90, 0);
				}, 3000);
			}
		},

		faceChecking: function faceChecking(memberId) {
			if (!this.checkFlag) return;
			this.checkFlag = false;
			var reqData = this.gateInfo;
			reqData.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			reqData.member_uid = memberId;
			var that = this;
			this.$http.post(this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + '/Check/faceCheck', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
				console.log(response);
				if (response.data.status == "success") {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					//开闸
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
					setTimeout(function () {
						that.message = "请面对摄像头刷脸验票或将票券上的二维码放在扫码器前扫码验票";
					}, 3000);
					that.msgRestore(3000);
				} else {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					that.msgRestore(3000);
				}

				setTimeout(function () {
					that.checkFlag = true;
					global.LOCAL_DATA.devInfo.checkFlag = false;
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().faceSearchUser(1, that.groupId, 90, 0);
				}, 5000);
			}).catch(function (error) {
				global.LOCAL_DATA.devInfo.checkFlag = false;
				that.message = "网络异常，验票失败,请重试";
				that.checkFlag = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
				that.msgRestore(3000);
			});
		},

		msgRestore: function msgRestore(timer) {
			var that = this;
			if (!timer) timer = 5000;
			setTimeout(function () {
				that.checkStatus = false;
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().IDStartRead(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_ID, 0);
				that.message = "请面对摄像头刷脸验票或将票券上的二维码放在扫码器前扫码验票";
			}, timer);
		},

		employeeCheck: function employeeCheck(qrCode) {
			if (!this.checkFlag) return;
			this.checkFlag = false;
			var that = this;
			var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			reqData.gate_uid = this.gateInfo.gate_uid;
			reqData.gate_type = this.gateInfo.gate_type;
			reqData.enterprise_uid = this.gateInfo.enterprise_uid;
			reqData.qr_code = qrCode;
			var url = "";
			if (reqData.sign == "") {
				url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
			} else {
				url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
			}
			this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
				if (response.data.status == "success") {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					//开闸
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
					that.msgRestore();
				} else {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					that.msgRestore();
				}

				setTimeout(function () {
					that.checkFlag = true;
					global.LOCAL_DATA.devInfo.checkFlag = false;
				}, 500);
			}).catch(function (error) {
				global.LOCAL_DATA.devInfo.checkFlag = false;
				that.message = "网络异常，验票失败,请重试";
				that.checkFlag = true;
				that.checkStatus = false;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
				that.msgRestore();
			});
		},

		//扫码验票
		check: function check(qrCode) {
			if (!this.checkFlag) return;
			this.checkFlag = false;

			if (qrCode == "TL20180808752033987" && this.debugFlag) {
				this.message = "请注意，测试验票成功，请入闸";
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(this.message);
				//开闸
				__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
				this.checkFlag = true;
				global.LOCAL_DATA.devInfo.checkFlag = false;
				this.msgRestore();
				return;
			}
			var that = this;
			var reqData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["a" /* getSignReqData */])();
			reqData.gate_uid = this.gateInfo.gate_uid;
			reqData.gate_type = this.gateInfo.gate_type;
			reqData.enterprise_uid = this.gateInfo.enterprise_uid;
			reqData.store_uid = this.gateInfo.store_uid;
			reqData.qr_code = qrCode;
			var url = "";
			if (reqData.sign == "") {
				url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
			} else {
				url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
			}
			this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {

				if (response.data.status == "success") {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					//开闸
					__WEBPACK_IMPORTED_MODULE_2__assets_js_deviceOperate__["b" /* getDev */]().MBSwitch(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["DEVICE_CODE"].DT_MODBUS, 1, 0, 1000);
					that.msgRestore();
				} else {
					that.message = response.data.msg;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
					that.msgRestore();
				}
				setTimeout(function () {
					that.checkFlag = true;
					global.LOCAL_DATA.devInfo.checkFlag = false;
				}, 5000);
			}).catch(function (error) {

				global.LOCAL_DATA.devInfo.checkFlag = false;
				that.message = "网络异常，验票失败,请重试";
				that.checkFlag = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_jssFunction__["b" /* loadAudioSrc */])(that.message);
				that.msgRestore();
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "fMF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"init-content"}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),(_vm.errShow)?_c('div',{staticClass:"text-center",staticStyle:{"padding-top":"30px"}},[_c('button',{staticClass:"btn btn-warning btn-lg",attrs:{"type":"button"},on:{"click":function($event){_vm.quit()},"touchstart":function($event){_vm.quit()}}},[_vm._v("退出应用")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fN6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__ = __webpack_require__("+rw6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034059d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__ = __webpack_require__("QLI/");
function injectStyle (ssrContext) {
  __webpack_require__("0ypA")
  __webpack_require__("ckk5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034059d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fnFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = setCallBackFun;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jssFunction__ = __webpack_require__("gtZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deviceOperate__ = __webpack_require__("tjjf");
/**
 * Created by zoupeiyang on 2018/1/20.
 */



function setCallBackFun(fun) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__jssFunction__["c" /* isIE */])() && global.LOCAL_DATA.cashPayInfo.callBackInitFlag == 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__deviceOperate__["a" /* writeAppLog */])(4, "回调事件绑定成功..");
        global.LOCAL_DATA.cashPayInfo.callBackInitFlag = 1;
        document.getElementById("DeviceMgr").attachEvent("DeviceEvent", function (DeviceID, UserEvtID, RetCode, RetMsg) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__deviceOperate__["a" /* writeAppLog */])(4, "回调事件日志：DeviceID：" + DeviceID + " UserEvtID:" + UserEvtID + " RetCode:" + RetCode + " RetMsg:" + RetMsg);

            fun(DeviceID, UserEvtID, RetCode, RetMsg);
        });
    } else if (global.LOCAL_DATA.cashPayInfo.callBackInitFlag == 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__deviceOperate__["a" /* writeAppLog */])(4, "回调事件绑定成功..");
        global.LOCAL_DATA.cashPayInfo.callBackInitFlag = 1;
        window.onDeviceEvent = function (DeviceID, UserEvtID, RetCode, RetMsg) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__deviceOperate__["a" /* writeAppLog */])(4, "回调事件日志：DeviceID：" + DeviceID + " UserEvtID:" + UserEvtID + " RetCode:" + RetCode + " RetMsg:" + RetMsg);
            fun(DeviceID, UserEvtID, RetCode, RetMsg);
        };
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "gtZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export timeMsg */
/* unused harmony export getUnixTime */
/* unused harmony export nowDate */
/* unused harmony export nowYear */
/* unused harmony export nowDates */
/* unused harmony export nowAddDate */
/* unused harmony export nowAddDates */
/* unused harmony export nowMonthLastDay */
/* unused harmony export nowSubDate */
/* unused harmony export nowSubDates */
/* unused harmony export nowSubYear */
/* unused harmony export nowTime */
/* unused harmony export datetimeFormat */
/* unused harmony export LPad */
/* unused harmony export RPad */
/* harmony export (immutable) */ __webpack_exports__["d"] = getQueryString;
/* unused harmony export isMobileNumber */
/* unused harmony export createTradeNo */
/* unused harmony export createTicketNo */
/* unused harmony export createSettleNo */
/* unused harmony export empty */
/* harmony export (immutable) */ __webpack_exports__["c"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["e"] = androidClick;
/* unused harmony export changeVideoVolume */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadAudioSrc;
/* unused harmony export audioEnd */
/* unused harmony export getReqData */
/* harmony export (immutable) */ __webpack_exports__["a"] = getSignReqData;
/* unused harmony export getRandom */
/* unused harmony export netStatusChange */
/* unused harmony export isNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviceOperate__ = __webpack_require__("tjjf");
/**
 * Created by zoupeiyang on 2017/9/7.
 */

/**
 * Created by zoupeiyang on 16/5/13.
 */


/*
 * 定义常用的公共方法，需使用时引用该JS文件，非必须加载项
 */

//时间对象格式化
Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
};

function timeMsg() {
    var now = new Date();
    var hour = now.getHours();
    var out = "";
    if (hour < 6) {
        out += "凌晨好";
    } else if (hour < 9) {
        out += "早上好";
    } else if (hour < 12) {
        out += "上午好";
    } else if (hour < 14) {
        out += "中午好";
    } else if (hour < 17) {
        out += "下午好";
    } else if (hour < 19) {
        out += "傍晚好";
    } else if (hour < 22) {
        out += "晚上好";
    } else {
        out += "夜里好";
    }
    var dayNames = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    out += "，  今天是" + parseInt(now.getYear() + 1900) + "年" + (now.getMonth() + 1) + "月" + now.getDate() + "日" + " " + dayNames[now.getDay()] + "";
    return out;
}

//获取时间戳
function getUnixTime(dateStr) {
    var newstr = dateStr.replace(/-/g, '/');
    var date = new Date(newstr);
    var time_str = date.valueOf();
    return time_str;
}

//返回当前日期
function nowDate() {
    var dt = new Date();
    return dt.format("yyyy-MM-dd");
}

//返回当前日期的年月
function nowYear() {
    var dt = new Date();
    return dt.format("yyyy-MM");
}

//返回当前日期戳
function nowDates() {
    var dt = new Date();
    return dt.format("yyyyMMdd");
}

//返回当前日期加一天
function nowAddDate() {
    var now = new Date();
    now.setDate(now.getDate() + 1);
    return now.format("yyyy-MM-dd");
}

function nowAddDates() {
    var now = new Date();
    now.setDate(now.getDate() + 1);
    return now.format("yyyy-MM");
}
//获取本月最后一天
function nowMonthLastDay() {
    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var year = new Date(nextMonthFirstDay - oneDay).getFullYear();
    var month = new Date(nextMonthFirstDay - oneDay).getMonth() + 1;
    var monthLastDay = new Date(nextMonthFirstDay - oneDay).getDate();
    var da = year + "-" + month + "-" + monthLastDay;
    return da;
}
function nowSubDate(id) {
    var now = new Date();
    now.setDate(now.getDate() - id);
    return now.format("yyyyMMdd");
}
function nowSubDates(id) {
    var now = new Date();
    now.setDate(now.getDate() - id);
    return now.format("yyyyMM");
}
//返回昨天日期
function nowSubYear(id) {
    var now = new Date();
    now.setDate(now.getDate() - id);
    return now.format("yyyy-MM-dd");
}

//取当前时间,返回 yyyy-MM-dd hh:mm:ss
function nowTime() {
    var dt = new Date();
    return dt.format("yyyy-MM-dd hh:mm:ss");
}

function datetimeFormat(format) {
    var dt = new Date();
    return dt.format(format);
}

//左填补,支持中文
function LPad(str, len, fillval) {
    return new Array(Math.abs(str.toString().length - (len + 1))).join(fillval) + str;
}

//右填补,支持中文
function RPad(str, len, fillval) {
    return str + new Array(Math.abs(str.toString().length - (len + 1))).join(fillval);
}

function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return r[2];
    return null;
}

//判断手机号是否合法
function isMobileNumber(mobileNumber) {
    var patrn = /^1\d{10}$/;
    if (!patrn.test(mobileNumber)) return false;
    return true;
}

/**
 * 创建订单号
 */
function createTradeNo() {

    return global.LOCAL_DATA.systemInfo.devInfo.dev_id + new Date().valueOf();
}

function createTicketNo() {
    return global.LOCAL_DATA.systemInfo.devInfo.dev_id + parseInt(new Date().valueOf() / 1000);
}
function createSettleNo() {
    return global.LOCAL_DATA.systemInfo.devInfo.dev_id + parseInt(new Date().valueOf() / 1000);
}

//对字符串判空
function empty(object) {
    if (object == null || object == "" || object == undefined) return true;else return false;
}

function isIE() {
    var explorer = navigator.userAgent;
    if (explorer.indexOf("MSIE") >= 0 || explorer.indexOf("Windows") >= 0) {
        return true;
    } else {
        return false;
    }
}

//是否是android上的点击事件
function androidClick() {

    // let version = getDev().GetSystemEnv('ROOTPATH');
    // if(version.substr(version.length-1,1)=="\\"&&window.event.type=="click"){
    //     return true;
    // }else {
    //     return false;
    // }


    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
    if (window.event.type == "click" && isAndroid) {
        return true;
    } else return false;
}

//改变视频声音大小
function changeVideoVolume(volume) {

    if (volume == undefined) volume = 0.2;
    try {
        document.getElementById("video").volume = volume;
        // $("#appFrame2").contents().find("#video")[0].volume = volume;
    } catch (e) {}
}

function loadAudioSrc(tex, vol, per, spd, pit) {

    try {
        if (!global.LOCAL_DATA.devInfo.onLine) return;
        changeVideoVolume(0.01);
        var cuid = global.LOCAL_DATA.systemInfo.devInfo.dev_id;
        if (!vol) vol = 9;
        if (!per) {
            per = global.LOCAL_DATA.devInfo.systemSetUp.sound_sex;
        }
        if (!spd) spd = 5;
        if (!pit) pit = 5;
        tex = encodeURI(tex);
        var tok = global.LOCAL_DATA.systemInfo.devInfo.baidu_volume_token;
        var audio = document.getElementById("audio");
        audio.src = "http://tsn.baidu.com/text2audio?tex=" + tex + "&lan=zh&cuid=" + cuid + "&ctp=1&tok=" + tok + "&vol=" + vol + "&per=" + per + "&spd=" + spd + "&pit=" + pit;

        //safari浏览器不支持自动播放语音功能
        audio.play();
    } catch (e) {}
}

function audioEnd() {
    changeVideoVolume(0.8);
}

function getReqData() {

    var reqData = {};
    reqData.enterprise_uid = global.LOCAL_DATA.systemInfo.devInfo.enterprise_uid;
    reqData.store_uid = global.LOCAL_DATA.systemInfo.devInfo.store_uid;
    reqData.dev_id = global.LOCAL_DATA.systemInfo.devInfo.dev_id;
    return reqData;
}

function getSignReqData() {

    var reqData = {};
    reqData.dev_sn = global.LOCAL_DATA.devInfo.devSn;
    reqData.random = getRandom(10);
    reqData.time_stamp = new Date().valueOf();
    reqData.sign = getSign(reqData.dev_sn, reqData.random, reqData.time_stamp);
    reqData.enterprise_uid = global.LOCAL_DATA.systemInfo.devInfo ? global.LOCAL_DATA.systemInfo.devInfo.enterprise_uid : "";
    return reqData;
}

function getSign(devSn, random, timeStamp) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviceOperate__["e" /* tlMd5 */])("dev_sn=" + devSn + "&random=" + random + "&time_stamp=" + timeStamp + "&key=" + global.LOCAL_DATA.devInfo.tlKey);
}

/**
 * 获取随机数
 * @param n
 * @returns {string}
 */
function getRandom(n) {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var res = "";
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        res += chars[id];
    }
    return res;
}

/**
 * 网络状态图标
 * @param onLine
 */
function netStatusChange(onLine) {
    // if (onLine) {
    //     document.getElementById("netStatus").setAttribute("src", "../../../static/image/theme/default/dot.png")
    // } else {
    //     document.getElementById("netStatus").setAttribute("src", "../../../static/image/theme/default/net-bad.png")
    //
    // }

}

function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(val) || regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "hPLS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mlqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("tk/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbccb6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Ogus");
function injectStyle (ssrContext) {
  __webpack_require__("dPHu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dbccb6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbccb6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oQmD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, "body {\n  background-color: #104E8B;\n  color: whitesmoke;\n  font-family: \"Microsoft YaHei\" ! important;\n  font-size: 16px;\n}\n.header2 {\n  height: 60px;\n  line-height: 60px;\n  font-size: 20px;\n}\n.content {\n  padding-top: 40px;\n}\n.footer2 {\n  height: 40px;\n  line-height: 40px;\n  font-size: 14px;\n  padding-left: 15px;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n", ""]);

// exports


/***/ }),

/***/ "p91O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row header2 jss-transparent"},[_c('div',{staticClass:"col-lg-12 text-center"},[_c('span',{staticStyle:{"font-size":"30px"}},[_vm._v("手持检票系统"+_vm._s(_vm.versionNo))])])]),_vm._v(" "),_c('div',{staticClass:"row content"},[_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('div',{staticClass:"col-lg-12 text-center",staticStyle:{"padding-top":"30px","font-size":"20px"}},[_c('div',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.checkTime))])])]),_vm._v(" "),_c('div',{staticClass:"row jss-transparent navbar navbar-default navbar-fixed-bottom",staticStyle:{"height":"60px","font-size":"14px","padding-left":"15px"}},[_c('div',{staticClass:"col-lg-12",staticStyle:{"line-height":"30px"}},[_vm._v("本机序列号：\n\t\t\t"),_c('span',[_vm._v(_vm._s(_vm.devSn))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"15px"}},[_vm._v(_vm._s(_vm.versionNo))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('span',[_vm._v(_vm._s(_vm.gateInfo.store_name))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q0u+":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Created by zoupeiyang on 2017/9/19.
 */

var globalData = {};
//接收云端信息
globalData.systemInfo = {};

//商家信息
globalData.enterpriseInfo = {};
//终端所属门店的信息
globalData.storeInfo = {};
//终端信息
globalData.devInfo = {};
//API信息
globalData.apiInfo = {};

globalData.enterpriseInfo.BrankName = "天羚自助演示系统";
globalData.enterpriseInfo.BrandLogo = "../../../static/image/tllogo.png";
globalData.enterpriseInfo.wxAccountIsSet = true;
globalData.enterpriseInfo.wxQrCode = "../../../static/image/qrcode.jpg";

globalData.storeInfo.storeAd = "../../../static/image/offLine/off-line-ad2.jpg";
globalData.storeInfo.products = new Array();
globalData.storeInfo.selectedProducts = new Array();
globalData.storeInfo.selectedRecharge = {};

//现金支付信息
globalData.cashPayInfo = {};
globalData.cashPayInfo.payMoney = 0;
globalData.cashPayInfo.receiveMoney = 0;
globalData.cashPayInfo.payFinishFlag = 0;
globalData.cashPayInfo.callBackInitFlag = 0;
globalData.cashPayInfo.payLog = "";

//倒计时
globalData.devInfo.countDownTime = 120;
globalData.devInfo.homePage = "/";
//天羚终端系统版本{myBase基础版，myFull美业全屏版本}
globalData.devInfo.tlVersion = "/myFull";
globalData.devInfo.weatherInfo = "";
globalData.devInfo.onLine = true;
globalData.devInfo.debug = false;
globalData.devInfo.devSn = "";
globalData.devInfo.cashMsg = "本机接收纸币1元、5元、10元、20元";
globalData.devInfo.cashCode = 1 + 2 + 4 + 8;
globalData.devInfo.payType = 1; //支付方式，0表现金支付，1表示支付宝扫码支付，2表示微信扫码支付，3表示会员卡支付，4表示银行卡支付，5表示公众号微信支付
globalData.devInfo.selectedProducts = new Array();
globalData.devInfo.imagePath = "http://image.tl-self.com";
globalData.devInfo.memberUid = "";
globalData.devInfo.tradeType = 1; //0表示充值，1表示消费购买
globalData.devInfo.SettleNo = ""; //结算单号
globalData.devInfo.devSn = ""; //终端唯一序列号
globalData.devInfo.tlKey = "mO3p4Qj81q8DwRil";
globalData.devInfo.rsaPublicKey = "";
globalData.devInfo.SelectWay = 1; //1表示堂食，2表示外带
//当前页面是否允许打开系统设置，0表示允许，1表示禁止，如投币页面禁止打开设置页面
globalData.devInfo.setOpen = 0;
globalData.devInfo.remarkName = ""; //口味
globalData.devInfo.deskNum = ""; //台号
globalData.devInfo.lunchBoxNum = 0; //饭盒数量
globalData.devInfo.idCardInfos = new Array(); //身份证信息

//最大排队号
globalData.devInfo.maxQueueNumber = 1;
globalData.devInfo.systemSetUp = {};
globalData.devInfo.systemSetUp.show_line_up = false;
globalData.devInfo.systemSetUp.language = "zh-CN";
globalData.devInfo.systemSetUp.print_queue_number = true;
globalData.devInfo.systemSetUp.print_qr_code = true;
globalData.devInfo.systemSetUp.theme = "default";
globalData.devInfo.systemSetUp.price_show_plan = 0;
//语音播报声音性别，0为女声，1为男声音
globalData.devInfo.systemSetUp.sound_sex = 0;

globalData.version = "V2089";

global.LOCAL_DATA = globalData;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rMqd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oQmD");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./HandCheck.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./HandCheck.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tEpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPum":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tjjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getDev;
/* harmony export (immutable) */ __webpack_exports__["c"] = openDevice;
/* unused harmony export closeDevice */
/* unused harmony export getDeviceStatus */
/* unused harmony export driverIsOpen */
/* unused harmony export setDeviceLogFile */
/* unused harmony export getDevSn */
/* harmony export (immutable) */ __webpack_exports__["d"] = getLastMsg;
/* unused harmony export getLastCode */
/* unused harmony export getStatusMsg */
/* harmony export (immutable) */ __webpack_exports__["e"] = tlMd5;
/* unused harmony export JSDESEncrypt */
/* unused harmony export JSDESDecrypt */
/* unused harmony export RSASetPublickey */
/* unused harmony export RSAPublicDecrypt */
/* unused harmony export RSAPublicEncrypt */
/* unused harmony export SystemCtrl */
/* unused harmony export getDevName */
/* unused harmony export RPPrintText */
/* unused harmony export RPCutPaper */
/* unused harmony export RPPrintLOGO */
/* unused harmony export RPPrintBarCode */
/* harmony export (immutable) */ __webpack_exports__["a"] = writeAppLog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("vgQg");
/**
 * 获取硬件驱动控制单元对象，即网页中创建的OCX对象名称，在调用以下接口之前，必须先调用此函数传入硬件驱动控制单元对象。
 获取成功后，可按接口文档定义的接口方法进行调用，如调用打开端口
 getDev().OpenDevice(DT_PINPAD,'','','');
 */




function getDev() {
    var devOperate = undefined;
    var explorer = navigator.userAgent;
    //IE浏览器
    if (explorer.indexOf("MSIE") >= 0 || explorer.indexOf("Windows") >= 0) {
        devOperate = window['DeviceMgr'];
    } else {
        //android下使用
        devOperate = window.jsDeviceCtrl;
    }

    return devOperate;
}

function openDevice(deviceID, dllPath, szPort, szParam) {

    var result = 1;
    try {
        result = getDev().OpenDevice(deviceID, dllPath, szPort, szParam);
    } catch (e) {
        result = 2;
    }
    return result;
}

function closeDevice(deviceID) {

    var result = 1;
    try {
        result = getDev().CloseDevice(deviceID);
    } catch (e) {
        result = 2;
    }
    return result;
}

function getDeviceStatus(deviceID) {

    var result = 1;
    try {
        result = getDev().GetDeviceStatus(deviceID);
    } catch (e) {
        result = 2;
    }
    return result;
}

function driverIsOpen(deviceID) {

    var result = 1;
    try {
        result = getDev().DriverIsOpen(deviceID);
    } catch (e) {
        result = 2;
    }
    return result;
}

function setDeviceLogFile(deviceID, logLevel, filePath) {

    var result = 1;
    try {
        result = getDev().SetDeviceLogFile(deviceID, logLevel, filePath);
    } catch (e) {
        result = 2;
    }
    return result;
}

function getDevSn() {
    try {
        return "TL_MY_01";
        return getDev().GetHDSN();
    } catch (e) {
        return "TL_MY_01";
    }
}

function getLastMsg() {

    var result = 1;
    try {
        result = getDev().GetLastMsg();
    } catch (e) {
        result = 2;
    }
    return result;
}

function getLastCode() {

    return getDev().GetLastCode();
}

function getStatusMsg() {

    return getDev().GetLastMsg();
}

/**
 * md5加密
 * @param val
 * @returns {*}
 */
function tlMd5(val) {

    try {
        return getDev().GetMD5(val);
    } catch (e) {
        return "";
    }
}

/**
 * des加密
 * @param val
 * @returns {*}
 * @constructor
 */
function JSDESEncrypt(val) {
    return getDev().JSDESEncrypt(val);
}

/**
 * des解密
 * @param val
 * @returns {*}
 * @constructor
 */
function JSDESDecrypt(val) {
    return getDev().JSDESDecrypt(val);
}

/**
 * rsa设置公钥
 * @param val
 * @returns {*}
 * @constructor
 */
function RSASetPublickey(val) {
    return getDev().RSASetPublickey(val);
}

/**
 * rsa公钥解密
 * @param val
 * @returns {*}
 * @constructor
 */
function RSAPublicDecrypt(val) {
    // RSASetPublickey(global.LOCAL_DATA.devInfo.rsaPublicKey);
    return getDev().RSAPublicDecrypt(val);
}

/**
 * 公钥加密
 * @param val
 * @returns {*}
 * @constructor
 */
function RSAPublicEncrypt(val) {
    return getDev().RSAPublicEncrypt(val);
}

/**
 * 1重启 2关机 3休眠,10表示退到桌面，11表示清理缓存 12表示清理垃圾
 * @param val
 * @constructor
 */
function SystemCtrl(val) {
    return getDev().SystemCtrl(val);
}

function getDevName(devCode) {

    var devName = "";
    switch (devCode) {
        case __WEBPACK_IMPORTED_MODULE_0__config__["DEVICE_CODE"].DT_RPRN:
            devName = "清单打印机";
            break;
        case __WEBPACK_IMPORTED_MODULE_0__config__["DEVICE_CODE"].DT_CASH:
            devName = "纸币识别器";
            break;
        case __WEBPACK_IMPORTED_MODULE_0__config__["DEVICE_CODE"].DT_SCREADER:
            devName = "读卡器";
            break;
        case __WEBPACK_IMPORTED_MODULE_0__config__["DEVICE_CODE"].DR_NETWORK:
            devName = "网络组件";
            break;
        case __WEBPACK_IMPORTED_MODULE_0__config__["DEVICE_CODE"].DT_DRVID:
            devName = "发卡器";
            break;

    }

    return devName;
}

function RPPrintText(DEVID, szText, szStyle) {
    return getDev().RPPrintText(DEVID, szText, szStyle);
}

function RPCutPaper(DEVID) {
    RPPrintText(DEVID, "\n\n", ""); //切纸离打印内容需走纸一定距离
    return getDev().RPCutPaper(DEVID, 0);
}

function RPPrintLOGO(DEVID, idx) {
    return getDev().RPPrintLOGO(DEVID, idx);
}

//打印条形码
/*
 szData :条码内容
 hasText:0条码上下方不打印内容文字，1条码下方打印文字，2条码上方打印文字
 */
function RPPrintBarCode(szData, hasText) {
    //73 为条码类型CODE128 ; 90为条码高度； 2为条码间隔
    return getDev().RPPrintBarCode(__WEBPACK_IMPORTED_MODULE_0__config__["DEVICE_CODE"].DT_RPRN, szData, 73, 90, 2, hasText);
}

function writeAppLog(logLevel, msg) {
    var str = "";
    switch (logLevel) {
        case 1:
            str = "异常";
            break;
        case 2:
            str = "错误";
            break;
        case 3:
            str = "警告";
            break;
        case 4:
            str = "信息";
            break;
        case 5:
            str = "调试";
            break;
        case 6:
            str = "同步";
            break;
        default:
            str = "其它";
    }
    try {
        var dt = new Date();
        var system = getDev().GetSystemEnv("SYSTEM");
        var splitStr = "\\";
        if (system == "Android") splitStr = "/";
        var LogPath = getDev().GetSystemEnv("LOGPATH");
        if (logLevel == 6) {
            LogPath = LogPath + dt.format('yyyyMM') + splitStr + dt.format('yyyyMMdd') + splitStr + 'Sync_' + dt.format('yyyyMMdd') + '.log';
        } else {
            LogPath = LogPath + dt.format('yyyyMM') + splitStr + dt.format('yyyyMMdd') + splitStr + 'Run_' + dt.format('yyyyMMdd') + '.log';
        }
        getDev().WriteTextFile(LogPath, dt.format("hh:mm:ss") + "\t" + str + "\t" + msg);
        if (logLevel <= 2) {
            LogPath = getDev().GetSystemEnv("LOGPATH") + dt.format('yyyyMM') + splitStr + dt.format('yyyyMMdd') + splitStr + 'Err_' + dt.format('yyyyMM') + '.log';
            getDev().WriteTextFile(LogPath, dt.format("yyyy-MM-dd hh:mm:ss") + "\t" + str + "\t" + msg);
        }
    } catch (e) {
        ;
    }
}

/***/ }),

/***/ "tk/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__ = __webpack_require__("tjjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_jssFunction__ = __webpack_require__("gtZW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            logoHeight: 0,
            pageWrongFlag: false,
            wrongMsg: "",
            oemShow: true
        };
    },

    beforeMount: function beforeMount() {},
    mounted: function mounted() {
        this.setTime();
    },
    methods: {
        setTime: function setTime() {
            var that = this;
            var reqData = {};
            this.$http.post(this.GlobalConfig.APP_CONFIG.API_HOST + "getNowTime", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
                that.syncDevTime(response.data.data);
                that.init();
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["a" /* writeAppLog */](4, "同步时间异常");
                that.init();
            });
        },
        init: function init() {
            try {
                if (global.LOCAL_DATA.devInfo.debug) {
                    global.LOCAL_DATA.devInfo.devSn = "TL_MY_01";
                } else {
                    var _devSn = __WEBPACK_IMPORTED_MODULE_2__assets_js_jssFunction__["d" /* getQueryString */]("v");
                    if (_devSn == "TL_MY_2" || _devSn == "TL_JQ_2" || _devSn == "TL_CY_2" || _devSn == "TL_MY_01") {
                        global.LOCAL_DATA.devInfo.devSn = _devSn;
                    } else {
                        global.LOCAL_DATA.devInfo.devSn = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetHDSN();
                    }
                }
            } catch (e) {
                this.pageWrongFlag = true;
                this.oemShow = false;
                this.wrongMsg = "售票客户端尚未安装或安装失败。";
                return;
            }

            //是否进入主页面标志
            var reqData = {};
            reqData.dev_sn = global.LOCAL_DATA.devInfo.devSn;
            var devSn = global.LOCAL_DATA.devInfo.devSn;
            var that = this;
            var version = 2;
            var url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "terminal/init";
            if (version == 3) {
                url = this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "terminalApp/init";
            }
            var devHardware = [];
            var versions = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetSystemEnv("SYSTEM");
            var fileName = "";
            if (versions == "Android") {
                fileName = "/mnt/sdcard/tl/conf/DeviceCfg.ini";
            } else {
                fileName = "D:\\TerminalApp\\Config\\DeviceCfg.ini";
            }
            _.forEach(that.GlobalConfig.DEVICE_CODE, function (n) {
                if (n != 910 && n != 140 && n != 310) {
                    try {
                        var result = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["c" /* openDevice */](n * 1, "", "", "");
                        if (result == 0) {

                            var ret = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetDeviceStatus(n * 1);
                            var hardwareInfo = {};
                            hardwareInfo.dev_des = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["d" /* getLastMsg */]();
                            hardwareInfo.dev_code = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetDeviceStatus(n * 1);
                            hardwareInfo.part_name = n;
                            hardwareInfo.port = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetProfileString(fileName, "DT" + n, "Port", "");
                            hardwareInfo.parm = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetProfileString(fileName, "DT" + n, "Parm", "");
                            hardwareInfo.driver_name = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetProfileString(fileName, "DT" + n, "DriverName", "");
                            hardwareInfo.driver_ver = __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().GetProfileString(fileName, "DT" + n, "DriverVer", "");
                            devHardware.push(hardwareInfo);
                        }
                    } catch (e) {}
                }
            });
            reqData.hardwareInfo = devHardware;
            this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reqData), this.GlobalConfig.APP_CONFIG.HEADERS).then(function (response) {
                if (response.data.status == "success") {
                    var _url = response.data.devInfo.version_url;
                    if (devSn == "TL_MY_2" || devSn == "TL_JQ_2" || devSn == "TL_CY_2" || devSn == "TL_MY_01") {
                        _url = response.data.devInfo.version_url + "?v=" + devSn;
                    }
                    window.location.href = _url;
                } else {
                    that.pageWrongFlag = true;
                    that.oemShow = false;

                    that.wrongMsg = response.data.msg;
                }
            }).catch(function (error) {
                that.oemShow = false;
                that.wrongMsg = "网络异常，请退出检查终端机是否已经联网";
                that.pageWrongFlag = true;
                setTimeout(function () {
                    that.init();
                }, 20000);
            });
        },

        syncDevTime: function syncDevTime(strTime) {
            try {
                var date = strTime.split(" ");
                var days = date[0].split("-");
                var times = date[1].split(":");
                __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().SyncSysTime(days[0] * 1, days[1] * 1, days[2] * 1, times[0] * 1, times[1] * 1, times[2] * 1);
                __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["a" /* writeAppLog */](4, "终端同步系统时间成功");
            } catch (e) {
                __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["a" /* writeAppLog */](4, "同步系统时间[" + strTime + "]错误!" + e.toString());
            }
        },
        //退出系统
        quit: function quit() {
            if (__WEBPACK_IMPORTED_MODULE_2__assets_js_jssFunction__["e" /* androidClick */]()) return;
            __WEBPACK_IMPORTED_MODULE_1__assets_js_deviceOperate__["b" /* getDev */]().SystemCtrl(10);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "uuxJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, "html {\n  font-size: 62.5%;\n}\nbody {\n  font-family: \"Microsoft YaHei\" ! important;\n  -moz-user-select: none;\n  /*火狐*/\n  -webkit-user-select: none;\n  /*webkit浏览器*/\n  -ms-user-select: none;\n  /*IE10*/\n  -khtml-user-select: none;\n  /*早期浏览器*/\n  user-select: none;\n  font-size: 2.5rem;\n  margin: auto;\n}\na:link {\n  text-decoration: none;\n  color: white;\n}\na:visited {\n  text-decoration: none;\n  color: white;\n}\na:hover {\n  text-decoration: none;\n  color: white;\n}\na:active {\n  text-decoration: none;\n  color: white;\n}\na {\n  cursor: pointer;\n  color: white;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n.module_title {\n  font-size: 30px;\n  font-weight: bolder;\n}\n.money {\n  color: red;\n}\n", ""]);

// exports


/***/ }),

/***/ "vgQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_CONFIG", function() { return APP_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEVICE_CODE", function() { return DEVICE_CODE; });
/**
 * Created by zoupeiyang on 2017/9/22.
 */
var APP_CONFIG = {

    BASE_API3_HOST: "https://api3.tl-self.com/index.php/api/v1/",
    // BASE_API3_HOST: "http://api3.tl.me/index.php/api/v1/",
    // BASE_API_HOST:"http://www.tlapi.me/index.php/api/",
    BASE_API_HOST: "http://api.tl-self.com/index.php/api/",
    CLIENT_API_HOST: "http://api.tl-self.com/index.php/api/client/",
    // API_HOST:"http://www.tlapi.me/index.php/api/terminal/",
    API_HOST: "http://api.tl-self.com/index.php/api/terminal/",
    // PAY_HOST:"http://pay.tl.me/index.php/index/index/",
    PAY_HOST: "http://pay.tl-self.com/index.php/index/index/",
    IMG_HOS: "http://image.jsscom.com",
    HEADERS: { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }, emulateJSON: true, timeout: 12000 },
    LOG_PATH: "D:\\TerminalApp\\Log\\",
    ANDROID_LOG_PATH: "",
    DB_PATH: "D:\\TerminalApp\\Data\\js_tl.db",
    // ANDROID_DB_PATH:"/data/cfg/js_tl.db",
    ANDROID_DB_PATH: "/mnt/sdcard/tl/js_tl.db",
    DB_NAME: "js_tl.db",
    TEST_EVENT_FLAG: false,
    CALL_BACK_FLAG: false

};

var DEVICE_CODE = {
    DT_CASH: 130,
    DT_SQLITE: 910,
    DT_CODE: 220,
    DT_RPRN: 100,
    DT_PRINT: 101,
    // DT_CREADER: 110,
    // DT_SCREADER: 250,
    DT_ID: 140,
    DT_MODBUS: 310
};



/***/ }),

/***/ "wfMF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uuxJ");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./index.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_deviceOperate__ = __webpack_require__("tjjf");
//
//
//
//
//
//

//  import {setDefault} from './assets/js/common/themeFunction'


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    methods: {
        deviceEventCallBack: function deviceEventCallBack(DeviceID, UserEvtID, RetCode, RetMsg) {
            this.$bus.emit('deviceCallBack', DeviceID, UserEvtID, RetCode, RetMsg);
        },

        deviceCallBack: function deviceCallBack(DeviceID, UserEvtID, RetCode, RetMsg) {

            //           writeAppLog(4,"父页面接收到事件，事件DeviceId:"+DeviceID);
            if (DeviceID == 1000) {
                this.GlobalConfig.APP_CONFIG.CALL_BACK_FLAG = true;
            }
        }
    },
    created: function created() {
        this.$bus.on('deviceCallBack', this.deviceCallBack);
        try {
            var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_js_deviceOperate__["b" /* getDev */])().TestEvent(100, "test");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_js_deviceOperate__["a" /* writeAppLog */])(4, "调用TestEvent结果：" + result);
            if (result == 0) {
                this.GlobalConfig.APP_CONFIG.TEST_EVENT_FLAG = true;
            }
        } catch (e) {
            this.GlobalConfig.APP_CONFIG.TEST_EVENT_FLAG = false;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.$bus.off('deviceCallBack', this.deviceCallBack);
    },

    mounted: function mounted() {
        //        setDefault("purple");
        //注册网页控件
        // setCallBackFun(this.deviceEventCallBack);


    }
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.61c3525b45663cf33544.js